import React from 'react';
import { ActionHeader } from '../../../../../modernization-common/side-panel/common/action-header';
import { useRelationshipsEnabled } from '../../../hooks/use-relationships-enabled';
import { useRelationshipHandlers } from '../../side-panel/hooks/use-relationship-handlers';
export const RelationshipsTriggerButton = () => {
  const isRelationshipsEnabled = useRelationshipsEnabled();
  const {
    createRelationshipWithEditableSource
  } = useRelationshipHandlers({
    drawerMode: 'stacked-drawer'
  });
  if (!isRelationshipsEnabled) return null;
  return <ActionHeader title="Relationships" titleTypography="small" onActionClick={createRelationshipWithEditableSource} />;
};